<footer class="bg-color-light-grey">
  <div class="container">
    <div class="nav">
      <ul class="navigation-group">
        <li class="navigation-link">
          <a routerLink="apresentacao" class="link">Apresentação</a>
        </li>
        <li class="navigation-link">
          <a routerLink="legislacao" class="link">Legislação</a>
        </li>
        <li class="navigation-link">
          <a routerLink="/lista-de-termos" class="link">Lista de termos</a>
        </li>
        <li class="navigation-link">
          <a routerLink="/faq" class="link">Perguntas frequentes</a>
        </li>
        <li class="navigation-link">
          <a routerLink="expediente" class="link">Expediente</a>
        </li>

        <li>
          <p class="navigation-title text-uppercase">Encontre um Curso</p>
        </li>
        <li class="navigation-link">
          <a routerLink="/cursos" class="link">Todos os cursos</a>
        </li>
        <li class="navigation-link">
          <a [routerLink]="['/']" fragment="eixo-tecnologico" class="link"
            >Cursos por eixo tecnológico</a
          >
        </li>
        <!-- li class="navigation-link">
          <a routerLink="/cursos/mudaram-nome" class="link">Cursos que mudaram de nome</a>
        </li -->
        <li class="navigation-link">
          <a
            routerLink="/cursos/mudaram-nome-tabela-convergencia"
            [queryParams]="{ filtro: 'mudaramnome' }"
            class="link"
            >Tabela de Convergência
          </a>
        </li>
        <!-- li class="navigation-link">
          <a routerLink="/cursos/nao-autorizados" class="link">Cursos excluídos ou não incluídos</a>
        </li -->
        <li class="navigation-link">
          <a routerLink="/cursos/tabela-submissao" class="link"
            >Tabela de Submissão
          </a>
        </li>
        <li class="navigation-link">
          <a routerLink="/cursos/experimentais" class="link"
            >Cursos em oferta experimental</a
          >
        </li>
        <li>
          <p class="navigation-title text-uppercase">Downloads</p>
        </li>
        <li class="navigation-link">
          <a
            target="_blank"
            rel="noopener"
            href="/cnct-api/catalogopdf"
            class="link"
            >Catálogo em PDF</a
          >
        </li>
        <li class="navigation-link">
          <a
            target="_blank"
            rel="noopener"
            (click)="downloadCsvCatalogoCnct()"
            class="link"
            >Catálogo em CSV</a
          >
        </li>
        <li class="navigation-link">
          <a
            target="_blank"
            rel="noopener"
            href="/cnct-api/relatorio-dados-atualizadospdf"
            class="link"
            >Registro de Alterações no Portal</a
          >
        </li>
        <li class="navigation-link">
          <a routerLink="/todas-edicoes" class="link">Todas as Edições</a>
        </li>
        <li>
          <p class="navigation-title text-uppercase">
            Ajude a melhorar o Catálogo
          </p>
        </li>
        <li class="navigation-link">
          <a routerLink="/envie-sugestao" class="link"
            >Envie sua sugestão de melhoria</a
          >
        </li>
      </ul>
      <ul class="navigation-group">
        <li>
          <p class="navigation-title text-uppercase">
            <a
              href="https://www.gov.br/mec/pt-br/canais_atendimento"
              class="link"
              target="_blank"
              rel="noopener"
              >Canais de Comunicação</a
            >
          </p>
        </li>

        <li class="navigation-link">
          <a
            href="https://www.gov.br/mec/pt-br/canais_atendimento/fale-conosco"
            class="link"
            target="_blank"
            rel="noopener"
            >Fale conosco</a
          >
        </li>
        <li>
          <p class="navigation-title text-uppercase icones">Redes Sociais</p>
          <app-social-networks></app-social-networks>
        </li>
      </ul>
      <ul class="navigation-group">
        <li>
          <p class="navigation-title text-uppercase">Links Externos</p>
        </li>
        <li class="navigation-link">
          <a
            href="https://cncst.mec.gov.br/"
            target="_blank"
            rel="noopener"
            class="link"
            >Catálogo Nacional dos Cursos Superiores de Tecnologia</a
          >
        </li>
        <li class="navigation-link">
          <a
            href="http://www.mtecbo.gov.br/cbosite/pages/home.jsf"
            target="_blank"
            rel="noopener"
            class="link"
            >Classificação Brasileira de Ocupações (CBO)</a
          >
        </li>
        <li class="navigation-link">
          <a
            href="http://sistec.mec.gov.br/consultapublicaunidadeensino/"
            target="_blank"
            rel="noopener"
            class="link"
            >Instituições ofertantes de cursos técnicos</a
          >
        </li>
      </ul>
    </div>

    <!-- <div id="footer-brasil" style="background-color: inherit"></div> -->

    <div id="my-footer-brasil" style="background-color: inherit">
      <div id="my-wrapper-footer-brasil">
        <a
          target="_blank"
          class="logo-acesso-footer"
          href="http://www.gov.br/acessoainformacao/"
          alt="Acesso à informação"
          title="Acesso à informação"
          rel="noopener"
        ></a>
        <a
          target="_blank"
          class="logo-ministerio-educacao"
          href="https://www.gov.br/mec/"
          alt="Ministério da Educação"
          title="Ministério da Educação"
          rel="noopener"
        ></a>
        <a
          target="_blank"
          class="logo-governo-federal"
          href="https://www.gov.br/"
          alt="Governo Federal"
          title="Governo Federal"
          rel="noopener"
        ></a>
      </div>
    </div>

    <hr class="hr-line bg-color-dark-grey" />
    <div class="text-center negrito">
      <span>CNCT | Versões F: {{ versionFront }} B: {{ version }}</span>
      <br />
      <span>© 2023 Ministério da Educação - Governo Federal</span>
    </div>
    <br />
  </div>
</footer>
